<template>
  <img src="@/assets/img/Icons/Wood.svg" />
</template>

<script>
export default {}
</script>

<style></style>
